export enum ReminderOption {
  Empty = '',
  Text = 'Text Message',
  Email = 'Email Address',
  Letter = 'Letter',
  ReminderRep = 'Appt Reminder Rep',
  None = 'None',
}
